import * as React from "react"
import { SimpelPage } from "../../../../utils"
import { WordPress } from "../../../wordpress/wordpress_api"
import { loader } from "../loader.mod"
import { Pagination } from "../pagination.mod"
import { VideosOverviewState } from "./VideosOverview.widget"
import { decodeHTMLEntities } from "../../../../helpers"
import { CookieSensitiveContentWrapper } from "../../../cms/blocks/cookiebar.mod"
import Plyr from "react-plyr"
import i18next from "i18next"

interface Props {
  videos: SimpelPage<WordPress.VideoResponse>
  isLoading: boolean
  onPropChange: <K extends keyof VideosOverviewState>(key: K, value: VideosOverviewState[K]) => void
  onTopicFilterChange: (value: string) => void
  onCountryFilterChange: (value: string) => void
  topics: WordPress.TaxonomyResponse[]
  countries: WordPress.TaxonomyResponse[]
  countryTaxonomy: number
  topicTaxonomy: number
}

declare var Optanon

export const VideosOverviewLayout = (props: Props) => {
  console.log('VideosOverviewLayout props', props)
  return (
    <section className="block block--grid block--grid--image block--grid--video">
      <div className="block__inner container container--m gutter--m spacing--m">
        <div className="block__filters">
          <select
            className="block__dropdown dropdown typo--s"
            onChange={(e) => props.onTopicFilterChange(e.currentTarget.value)}
            value={props.topicTaxonomy ? props.topicTaxonomy : null}
          >
            <option value={-1}>{i18next.t('videos.subjects')}</option>
            {props.topics && props.topics.map(topic => (<option key={topic.id} value={topic.id}>{decodeHTMLEntities(topic.name)}</option>))}
          </select>

          <select
            className="block__dropdown dropdown typo--s"
            onChange={(e) => props.onCountryFilterChange(e.currentTarget.value)}
            value={props.countryTaxonomy ? props.countryTaxonomy : null}
          >
            <option value={-1}>{i18next.t('videos.countries')}</option>
            {props.countries && props.countries.map(country => (<option key={country.id} value={country.id}>{country.name}</option>))}
          </select>
        </div>
        <div className="block__content">
          {!props.isLoading && props.videos.items.length > 0 && (
            <ul className="block__grid grid ls-columns">
              {props.videos.items.map((item) => {
                const hasTitle = true
                const hasIntro = item.acf.intro ? true : false
                const intro = item.acf.intro
                const title = item.title.rendered
                const useCookieBar = true
                const video_id = item.acf.youtube_id
                const video_type = "youtube"
                const hasCaption = item.acf.caption ? true : false
                const caption = item.acf.caption

                const gridItemInner: JSX.Element = (
                  <>
                    <div className="grid__content ls-bottom-item">
                      {hasCaption && (
                        <figcaption
                          className="block__caption typo--ms"
                          dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(caption) }}
                        />
                      )}
                      {hasTitle && (
                        <h3 className="grid__title typo--ml ff--primary ls-second-item">{decodeHTMLEntities(title)}</h3>
                      )}
                      {hasIntro && <p className="grid__intro">{decodeHTMLEntities(intro)}</p>}
                    </div>
                    <div className="grid__visual">
                      {useCookieBar ? (
                        <CookieSensitiveContentWrapper
                          groupId={4}
                          options={{
                            style: {
                              cookies_classname: "grid__cookie",
                              cookies_inner_classname: "grid__cookie-inner",
                              cookies_text_classname: "",
                              cookies_clickable_classname: "",
                            },
                          }}
                          placeholder={
                            <div className="media__placeholder spacing--m gutter--m">
                              <div className="text--styled">
                                <p>
                                  {window.wp.language == "nl" ? (
                                    <>
                                      Als u deze video wilt bekijken, pas dan 
                                      <a className="optanon-toggle-display" onClick={() => Optanon.ToggleInfoDisplay()}>
                                        hier uw cookievoorkeuren aan.
                                      </a>
                                    </>
                                  ) : (
                                    <>
                                      If you wish to view this video, please adjust your
                                      <a className="optanon-toggle-display" onClick={() => Optanon.ToggleInfoDisplay()}>
                                        cookie preferences here.
                                      </a>
                                    </>
                                  )}
                                </p>
                              </div>
                            </div>
                          }
                        >
                          <Plyr
                            // onPlay={() => window.dataLayer.push({
                            //   event: "event.fccorporate", category: "Video", action: "Start", label: window.location.pathname
                            // })}
                            // onPause={() => window.dataLayer.push({
                            //   event: "event.fccorporate", category: "Video", action: "Pause", label: window.location.pathname
                            // })}
                            type={video_type}
                            videoId={video_id}
                            hideControls={false}
                          />
                        </CookieSensitiveContentWrapper>
                      ) : (
                        <Plyr
                          // onPlay={() => window.dataLayer.push({
                          //   event: "event.fccorporate", category: "Video", action: "Start", label: window.location.pathname
                          // })}
                          // onPause={() => window.dataLayer.push({
                          //   event: "event.fccorporate", category: "Video", action: "Pause", label: window.location.pathname
                          // })}
                          type={video_type}
                          videoId={video_id}
                          hideControls={false}
                        />
                      )}
                    </div>
                  </>
                )

                return (
                  <li className="grid__item grid__item--image ls-item">
                    <div className="grid__inner ls-reversed border-radius--s">{gridItemInner}</div>
                  </li>
                )
              })}
            </ul>
          )}

          {props.isLoading && loader.run(undefined)}
          {!props.isLoading && props.videos.items.length == 0 && (
            <h3 className="lst__title ff--primary typo--ml">Geen resultaten</h3>
          )}
          {!props.isLoading && props.videos.total_pages > 1 && (
            <Pagination
              pager={{
                current_page: props.videos.current_page,
                items_per_page: props.videos.page_size,
                total_items: props.videos.total_items,
                total_pages: props.videos.total_pages,
              }}
              setPage={(page) => props.onPropChange("current_page", page)}
            />
          )}
        </div>
      </div>
    </section>
  )
}
